module.exports = __webpack_public_path__ + "img/TOYOTA.0e07fe7.jpg";